import moment from "moment";

const checkForDate = (monthArray, day) => {
  const len = monthArray.length;
  let lastDate = undefined;

  for (let i = 0; i <= len - 1; i++) {
    const date = monthArray[len - i - 1];
    const dateObj = moment(date.date, "YYYY-MM-DD");
    const isDateAvailable = moment(dateObj).format("dddd") === day;

    if (isDateAvailable) {
      lastDate = date.date;
      break;
    }
  }
  return lastDate;
};

const findLastAvailableDate = (data, months, day) => {
  let lastDateFound = "";
  let mon = [...months];

  for (let i = 0; i <= mon.length - 1; i++) {
    const monthArray = data[mon[i]];
    let date = checkForDate(monthArray, day);

    if (date) {
      lastDateFound = date;
      break;
    }
  }
  return lastDateFound;
};

export const getLastMarketDates = (array) => {
  const data = {};
  const months = new Set();

  array.forEach((date) => {
    const d = date.split("-");
    const prev = data[d[1]] || [];

    months.add(d[1]);

    data[d[1]] = [...prev, { day: d[2], date: date }];
  }); 
  const lastTuesday = findLastAvailableDate(data, months, "Tuesday"); 
  const lastThursday = findLastAvailableDate(data, months, "Thursday"); 
  //const lastTuesday = findLastAvailableDate(data, months, "Wednesday");
 // const lastThursday = findLastAvailableDate(data, months, "Tuesday"); 
  return { lastTuesday, lastThursday };
};

const isHolidayDate = (day, holiday) => {
  let status = false;
  if (holiday && holiday.length > 0) {
    for (let i = 0; i < holiday.length; i++) {
      const holidayDate = new Date(holiday[i].formattedDate);
      if (
        holidayDate.getFullYear() === day.getFullYear() &&
        day.getMonth() === holidayDate.getMonth() &&
        day.getDate() === holidayDate.getDate()
      ) {
        status = true;
        break;
      }
    }
  }
  return status;
};

const getFormattedDateReturn = (date) => {
  let dateFormatted = ("0" + date.getDate()).slice(-2);
  let monthFormatted = ("0" + (parseInt(date.getMonth())+1) ).slice(-2);
  return date.getFullYear()+'-'+monthFormatted+'-'+dateFormatted;
}

export const isMarketTime = () => {
  var format = 'HH:mm'
  var time = moment(moment().format('HH:mm'),format),
  beforeTime = moment('09:00', format),
  afterTime = moment('15:30', format);
  return time.isBetween(beforeTime, afterTime);
}

export const isWeekendDays =  () => {
  // const specialSessionData = await specialSession();
  // if(specialSessionData && Object.keys(specialSessionData).length > 0) {
  //     const NFO  = specialSessionData['NFO'][0];
  //     console.log("NFO", NFO)
  // }
  //console.log("specialSessionData", specialSessionData)
  var weekend = isSpecialSession() ? [] : ['Sat','Sun'];
  var day = moment(new Date()).format("ddd");
  var isWeekend = weekend.includes(day)?day=="Sat"?true:true:false;
  return isWeekend;
}

export const checkHoliday =  (holidays, date) => {
  
   return holidays.filter((item)=>item.formattedDate==date).length > 0 ? true : false;
}

export const pickChartPeriods = (token, period, holidays) => {
  let from;
  let to;
  const str = period.split('');
  if (str && str[1] === 'D' && str[0]) {
    let maximimDays = parseInt(str[0]);
    let count = 0;
  
    let d = new Date();
    while (count < maximimDays) {
      let day = d.getDay();
      var isWeekend = day === 6 || day === 0; // weekdays
  
      var holiday = isHolidayDate(d, holidays);
      if ((!isWeekend && !holiday) || isSpecialSession()) {
        count = count + 1;
      }
      if (count === 1 && !to) {
        to = new Date(d.getTime());
      }
      d.setDate(d.getDate() - 1);
    }
    d.setDate(d.getDate() + 1);
    from = d;
  } else if (str && str[1] === 'M' && str[0]) {
    let d = new Date();

    to = d;

    from = new Date();
    from.setMonth(from.getMonth() - parseInt(str[0]));
  } else if (str && str[1] === 'Y' && str[0]) {
    let d = new Date();

    to = d;

    from = new Date();
    from.setFullYear(from.getFullYear() - parseInt(str[0]));
  }
  return {
    to: getFormattedDateReturn(to),
    from: getFormattedDateReturn(from),
    isholiday:holidays && Object.keys(holidays).length > 0 && holidays?.filter((item)=>moment(item.formattedDate).format("YYYY-MM-DD")==moment().format("YYYY-MM-DD")).length > 0 ? true : false,
    isWeekend:isWeekend
  };
};

export const pickChartPeriodsForAllDates = (token, period, holidays) => {
  let from;
  let to;
  const str = period.split('');
  let maximimDays = parseInt(str[0]);

  if (str && str[1] === 'D' && str[0]) {
    let count = 0;
    let inr = 0;
    let d = new Date();
    d.setDate(d.getDate() + 1);
    var dates = [moment().format("YYYY-MM-DD")];
    for(let i = 1; i < 8; i++) {
        var day = moment().subtract(i,'d');
        var weekday = moment().subtract(i,'d').weekday()
        var isWeekend = weekday === 6 || weekday === 0; // weekdays
        var holiday = isHolidayDate(new Date(day), holidays);
        if (!isWeekend && !holiday) {
          dates.push(moment(day).format("YYYY-MM-DD"))
        }
        
 
    }
  } 
 dates.sort((a, b) => new Date(a) - new Date(b));
 var  newDates = dates.filter((item)=>{
    const weekDay = moment(item).format("dddd");
    const isWeekend = weekDay === 'Sunday' || weekDay === 'Saturday';

    if(!isWeekend) {
      return item;
    }
  })
  const holydayDate = holidays.filter((item)=>{
     if(item.formattedDate == moment().format("YYYY-MM-DD")) {
      return item.formattedDate
     };
  });

  if(holydayDate.length > 0) {
    var index = newDates.indexOf(holydayDate[0].formattedDate);
    newDates.splice(index , 1);
  }
  return {
    dates: newDates.slice((newDates.length - maximimDays), newDates.length),
    isholiday:holidays && Object.keys(holidays).length > 0 && holidays?.filter((item)=>moment(item.formattedDate).format("YYYY-MM-DD")==moment().format("YYYY-MM-DD")).length > 0 ? true : false,
 
  };
};

export const getArrayOfDatesBetween = (start_date, end_date) => {
  const date_format = "YYYY-MM-DD";
  const diff = getDateAsArray(end_date, date_format).diff(getDateAsArray(start_date, date_format), "days") + 1;
  const dates = [];
  for (let i = 0; i < diff; i++) {
    const nextDate = getDateAsArray(start_date, date_format).add(i, "day");
    const isWeekEndDay = nextDate.isoWeekday() > 5;
    if (!isWeekEndDay)
      dates.push(nextDate.format(date_format))
  }
  return dates;
};

const getDateAsArray = (date, date_format) => {
  return moment(date.split(/\D+/), date_format);
};



const isSpecialSession = () => {
  var isday = "";
  if(localStorage.getItem("specialSession")) {
     const specialSessionData = JSON.parse(localStorage.getItem("specialSession"));
     const filterDate = specialSessionData?.filter((item)=>item.formattedDate === moment().format("YYYY-MM-DD"))
     if(filterDate.length > 0) {
      isday = moment(filterDate[0].formattedDate).format("ddd")
     }
     console.log("specialSessionData", isday)
  }
  return isday;
};